import {Component, HostBinding} from '@angular/core';
import {MainTableComponent} from '../main-table.component';

@Component({
    selector: 'main-table',
    templateUrl: './normal-table.component.html',
    styleUrls: ['../main-table.component.scss']
})
export class StandartTableComponent extends MainTableComponent {

    @HostBinding('class') classes = 'flex flex-grow';

    public scrollTop() {
        document.querySelector('#table').scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }

}
